import { render, staticRenderFns } from "./DocCard.vue?vue&type=template&id=09a1fe42&scoped=true"
import script from "./DocCard.vue?vue&type=script&lang=js"
export * from "./DocCard.vue?vue&type=script&lang=js"
import style0 from "./DocCard.vue?vue&type=style&index=0&id=09a1fe42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1fe42",
  null
  
)

export default component.exports